var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
/**
 * Represents the TreeListToolbar component.
 */
var TreeListToolbar = /** @class */ (function (_super) {
    __extends(TreeListToolbar, _super);
    function TreeListToolbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @hidden
     */
    TreeListToolbar.prototype.render = function () {
        return (React.createElement("div", { className: "k-header k-grid-toolbar" }, this.props.children));
    };
    return TreeListToolbar;
}(React.Component));
export { TreeListToolbar };
//# sourceMappingURL=TreeListToolbar.js.map